import React from 'react';
import styled from 'styled-components';

import { Button } from 'widgets/button';
import { IconAlert } from 'widgets/icon';
import { HorizontalLayout } from 'widgets/Layout';
import { Modal } from 'widgets/Modal';
import { Text, Title } from 'widgets/Text';

export const DeleteConfirmModal = ({
    recordName,
    disabled,
    onClose,
    onDelete,
}: {
    recordName: string;
    disabled?: boolean;
    onClose: () => void;
    onDelete: () => void;
}) => {
    return (
        <Modal onClose={onClose} $maxWidth="500px">
            <div className="flex flex-col items-center gap-4 px-10 pt-10 pb-4 text-center">
                <StyledIconAlert size="large" />
                <Title modal>
                    <span className="block">You are about to delete</span>
                    <span className="mt-1 block break-words">{recordName}</span>
                </Title>
                <div className="flex flex-col gap-1">
                    <Text>To restore this record later, please contact support.</Text>
                    <Text>Are you sure you would like to continue?</Text>
                </div>
            </div>
            <Separator />
            <ButtonLayout $gap={16}>
                <Button size="large" buttonType="secondary" onClick={onClose} disabled={disabled}>
                    Cancel
                </Button>
                <Button size="large" buttonType="destructive" onClick={onDelete} disabled={disabled}>
                    Delete
                </Button>
            </ButtonLayout>
        </Modal>
    );
};

const StyledIconAlert = styled(IconAlert)`
    color: ${({ theme }) => theme.colors.red400};
`;

const ButtonLayout = styled(HorizontalLayout)`
    padding: 2rem;
`;

const Separator = styled.div`
    width: 100%;
    border-top: 1px solid ${({ theme }) => theme.border.light};
`;
